<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import Button from '../General/Button.vue';
import { TEXT } from '../../configs/text';
import { useSessionStore, useSignalRStore } from '../../stores';
import { computed } from 'vue';

const sessionStore = useSessionStore()
const signalr = useSignalRStore()

const isForcedScreen = computed(() => {
    return sessionStore.teacherSession
})

function handleForceScreenClick() {
    if (isForcedScreen.value) {
        signalr.unForceScreen()
        return
    }

    signalr.forceScreen()
}

const { t } = useI18n()
</script>

<template>
    <Button :color="isForcedScreen ? 'main' : 'warning'" @click="handleForceScreenClick">
        {{ t(isForcedScreen ? TEXT.unforce_screen : TEXT.force_screen) }}
    </Button>
</template>